import React from 'react';
import { clsx } from 'clsx';
import { Icon } from '@/ui/icons/Icon';
import { formatAmountWithSpacesAndSymbol } from '@/lib/amountUtils';
import styles from './CreditLineDetails.module.scss';

export interface CreditLineDetailsProps {
  creditAmount: number;
  contractDuration: number;
  monthlyPayment?: number;
  className?: string;
  showEditIcons?: boolean;
}

export const CreditLineDetails: React.FC<CreditLineDetailsProps> = ({
  creditAmount,
  contractDuration,
  monthlyPayment,
  className,
  showEditIcons = false,
}) => {
  return (
    <div className={clsx(styles.detailsSection, className)}>
      <div className={styles.sectionHeader}>
        <h3 className={styles.sectionTitle}>Detalii</h3>
      </div>

      <div className={styles.detailsCard}>
        {/* Credit Amount */}
        <div className={styles.detailRow}>
          <div className={styles.detailLeft}>
            <p className={styles.detailLabel}>Suma creditului</p>
          </div>
          <div className={styles.detailRight}>
            <div className={styles.detailValue}>
              <span className={styles.detailText}>
                {formatAmountWithSpacesAndSymbol(creditAmount, 'lei')}
              </span>
            </div>
          </div>
        </div>

        {/* Monthly Payment */}
        {monthlyPayment && (
          <div className={styles.detailRow}>
            <div className={styles.detailLeft}>
              <p className={styles.detailLabel}>Rata lunară</p>
            </div>
            <div className={styles.detailRight}>
              <div className={styles.detailValue}>
                <span className={styles.detailText}>
                  {formatAmountWithSpacesAndSymbol(monthlyPayment, 'lei')}
                </span>
              </div>
            </div>
          </div>
        )}

        {/* Contract Duration */}
        <div className={styles.detailRow}>
          <div className={styles.detailLeft}>
            <p className={styles.detailLabel}>Durata contractului</p>
          </div>
          <div className={styles.detailRight}>
            <div className={styles.detailValue}>
              <span className={styles.detailText}>{contractDuration}</span>
              <span className={styles.detailUnit}>luni</span>
              {showEditIcons && <Icon name="pen" className={styles.editIcon} />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
